'use client';

import { Button } from '@shared/components/shadcn';
import { GridView, ListView } from '@shared/icons';
import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type LayoutSwitcherProps = ComponentProps<'div'> & {
  isGrid: boolean;
  onLayoutChange: () => void;
};

function LayoutSwitcher({ className, isGrid, onLayoutChange, ...props }: LayoutSwitcherProps) {
  return (
    <div className={twMerge('flex items-center gap-0.5', className)} {...props}>
      <Button variant="ghost" size="icon-s" onClick={onLayoutChange} className="hover:bg-container" data-testid="grid-view-button" data-track-name="Grid View">
        <GridView size="extra-small" className={isGrid ? 'opacity-100' : 'opacity-50'} />
        <span className="sr-only">Grid view</span>
      </Button>
      <Button variant="ghost" size="icon-s" onClick={onLayoutChange} className="hover:bg-container" data-testid="list-view-button" data-track-name="List View">
        <ListView size="extra-small" className={!isGrid ? 'opacity-100' : 'opacity-50'} />
        <span className="sr-only">List view</span>
      </Button>
    </div>
  );
}

export { LayoutSwitcher };
